var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14D0C4C0-83BB-448E-B0CF-E2830264BC55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-478.000000, -587.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-send-email",
    transform: "translate(478.000000, 587.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.82,0.116 C23.6771453,-0.0032504928 23.4798842,-0.0333019864 23.308,0.038 L0.308,9.538 C0.119941058,9.61642744 -0.00171572116,9.80112586 0.000452886943,10.0048713 C0.00268008085,10.2086167 0.128292949,10.3906477 0.318,10.465 L6.65,12.924 C6.80556492,12.9846452 6.98113548,12.9636368 7.118,12.868 L15.518,6.894 C15.7313391,6.73975637 16.0277347,6.77735735 16.1958007,6.9799863 C16.3638666,7.18261525 16.3460249,7.48085323 16.155,7.662 L9.155,14.407 C9.05722884,14.5012438 9.00199661,14.631202 9.002,14.767 L9.002,21.5 C9.0026536,21.7252904 9.15389481,21.9223188 9.37136059,21.9811817 C9.58882638,22.0400446 9.81879954,21.9462021 9.933,21.752 L13.1,16.327 C13.16873,16.2100063 13.317995,16.1688145 13.437,16.234 L19.263,19.434 C19.4013333,19.5102411 19.5675576,19.5166343 19.7113382,19.4512437 C19.8551188,19.385853 19.9595468,19.2563687 19.993,19.102 L23.993,0.602 C24.0279988,0.420594087 23.9617514,0.234488659 23.82,0.116 Z",
    id: "icon-fill-color"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.96189cce.svg";
export { ForwardRef as ReactComponent };